import { Component, OnDestroy, OnInit, ViewChild, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { FilterService } from 'src/app/services/filter.service';
import { FormControl } from '@angular/forms';
import { Subscription, debounceTime } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { UserActivityService } from 'src/app/services/useractivity.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { MixpanelService } from 'src/app/services/mixpanel.service';

@Component({
    selector: 'widget-ngmultiselect',
    templateUrl: './multi-select.component.html',
    styleUrls: ['./multi-select.component.scss'],
    standalone: false
})
export class DynamicMultiSelect extends FieldType implements OnInit, OnDestroy, AfterViewChecked {    //implements OnInit

  @ViewChild('sc') ngSelect!: NgSelectComponent;
  
  override field: any;

  dynamicSelect = new FormControl()
  selectedItems: any[] = [];
  label: any
  isOpen: any = null
  selectAllLabel = 'Select All';
  isChecked = false;
  option: any
  opt: any; placeholder: any
  onValueChangeUpdate: any
  dropdownSettings = {}
  dropdownList = []
  itemsShowLimit = 2
  labelProp: any
  valueProp = '';
  reqSubcription: Subscription[] = []
  cardName: any
  cardId: any
  cardPage: any
  statusFromUrl: any
  isCrossed = false
  reasonFromUrl: any;
  showBy: any
  queryFilterData: any
  resetURLData = false;
  addParameter: any;
  staticKey :any
  staticValue:any
  additionalParameter: any
  isAddChecked = false;
  dashboardKey: any;
  defalutOption: any[] = [];
  previousSelection: any = []
  currentSelection: any = []
  enteredText: any;
  firstTime = true;
  toolTipVisible:any;
  selectAllAsNull=false;
  defaultFilter:any;
  userCanSelect:any;
  selectedDashboardKey:any;
  mixPanelConfiguration=false;
  apiJSonFlag:any;
  isdynamicLabel:any;
  isGrouped = false;
  groupLabelProp = 'src_category';
  groupSelectionStates: Map<string, boolean> = new Map();
  private needsCheckboxUpdate = false;

  decomm_flag=false;
  decommReplaceName:any;
  decommColor:any;
  decommlabel:any;
  decommTooltip:any;
  isRootSqBadge = false;
  
  // Define a variable to hold the subscription
  private parentControlSubscription: Subscription | undefined;

  constructor(public filterService: FilterService,
    private router: Router,
    private route: ActivatedRoute,
    private userActivityService: UserActivityService,
    private navigationService: NavigationService,
    private dashboardService: DashboardService,
    private mixpanelService: MixpanelService,
    private cdr: ChangeDetectorRef
  ) { super() }

  onOpen() {
    setTimeout(() => {
      const dropdownPanel = this.ngSelect.dropdownPanel(); // Access the dropdown panel
      if (dropdownPanel && dropdownPanel.scrollElementRef) {
        dropdownPanel.scrollElementRef.nativeElement.scrollTop = 0; // Set scroll to top
      }
    });
  }

  // Excel Filter to get data
  onFilterTextBoxChanged($event: any) {
    this.enteredText = $event.target.value.toLowerCase();

    let option = this.option.filter((f: any) => this.matchesSearch(f, this.enteredText))
    this.selectedItems = [...option]
    this.isAddChecked = false;

    if (!this.enteredText) {
      this.isChecked = false;
      if (this.selectedItems.length == this.option.length) {
        this.isChecked = true;
      }
    } else {
      if (this.selectedItems.length == option.length) {
        this.isChecked = true;
      }
    }
    return ($event.target as HTMLInputElement).value
  }

  // Search matches the option label, its group name, or its decomm tag label
  matchesSearch(item: any, text: any): boolean {
    const term = (text || '').toString().toLowerCase();
    const texts = [item?.[this.labelProp]];
    if (this.isGrouped) {
      texts.push(item?.[this.groupLabelProp]);
    }
    if (this.decomm_flag && item?.[this.decommReplaceName] == 'Y') {
      texts.push(this.decommlabel);
    }
    return texts.some((t: any) => t !== null && t !== undefined && t.toString().toLowerCase().includes(term));
  }

  // ng-select's own list filter, so the visible options match the same way
  searchFn = (term: string, item: any) => this.matchesSearch(item, term);

  toolTipKey: any;

  // Data present in the drop down or not
  areAllObjectsPresent(array1: any[], array2: any[], property: string): boolean {
    return array1.every(obj1 => array2.some(obj2 => obj2[property] == obj1[property]));
  }
  queryParam: any;
  tabId:any;
  searchByPrescriber:any;
  moduleName:any;
  bookmarkId:any;

  ngOnInit() {

    // Route
    this.route.params.subscribe((p: any) => {
      let cardName = p["cardName"];
      this.moduleName = p['module'] || '';

      // Query Params
      this.route.queryParams.subscribe((params: any) => {
        let decryptedParams = this.navigationService.decryptData(params);
        this.tabId = params["tab_id"];
        this.dashboardKey = decryptedParams["ds_key"];
        this.cardId = decryptedParams["cardId"] || '';
        
        this.searchByPrescriber = decryptedParams.prescriber || '';

        this.bookmarkId = p?.['bk_mrk_key'] || undefined;
      
        if(this.bookmarkId && !isNaN(Number(this.bookmarkId))) {
          this.queryFilterData = this.filterService.bookmarkFilterData;
        } else if (cardName || params?.['record'] == 'yes') {
          if (sessionStorage.getItem("filterData")) {
            let filter: any = sessionStorage.getItem("filterData")
            this.queryFilterData = JSON.parse(filter) || {};
          } else {
            this.queryFilterData = '';
          }
        } else {
          this.queryFilterData = '';
        }
      });
    });

    // this.route.params.subscribe((p: any) => {
      // this.cardName = p["cardName"];
      // this.cardId = p["cardId"];

      // this.dashboardKey = p["dashboardKey"];

      // if(sessionStorage.getItem('net_status_flr'))
      // let status:any = sessionStorage.getItem('net_status_flr')
      //   if(status)
      //     this.queryFilterData = JSON.parse(status);
      // // for KPI Control chart
      // if(this.cardName == 'pwt') {

      //   let status:any = sessionStorage.getItem('net_status_flr')
      //   if(status)
      //     this.queryFilterData = JSON.parse(status);
      // } else if (this.cardName == 'recdetail') {
      //   let rec:any = sessionStorage.getItem('rec_detail_flr')
      //   this.queryFilterData = rec ? JSON.parse(rec) : '';
      // } else if(this.cardId=='multi'){

      //   this.route.queryParams.subscribe((r:any)=> {
      //     this.queryFilterData = r ? r : {}
      //   })

      //   // let newData = sessionStorage.getItem('selectedKPIcontrol');
      //   // this.queryFilterData = newData ? JSON.parse(newData)   : '';

      // } else {
      //   this.queryFilterData =  '';
      // }
    // })


    // When Filter is Reseted
    this.reqSubcription.push(this.filterService.formReset.subscribe((res: any) => {
      
      this.queryFilterData = '';
      this.isChecked = true;
      this.isCrossed = true;
      this.resetURLData = true;
      this.selectedItems = this.option;

      this.filterService.previousSelectedItems[this.field.key] = this.option;
      this.filterService.selectedItem['multi'][this.field.key] = this.option;
      this.filterService.allOptionData['multi'][this.field.key] = this.option;

      // Reset re-selects everything, which is the same as no column restriction.
      this.publishDefectFieldSelection(this.selectedItems);

      if (this.addParameter) {
        this.filterService.duplicateParameter[this.addParameter] = this.stringifyMode(this.selectedItems, this.addParameter)
      }

      if (this.field?.parentKey == "") {
        this.field.formControl?.setValue(this.selectedItems)
      }

      this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, this.option.length, this.selectedItems, 'multiSelection', this.showBy, this.labelProp,"",this.option,'',this.label,{isGrouped: this.isGrouped, groupLabelProp: this.groupLabelProp})
    }), this.filterService.intractiveFilter
    .pipe(debounceTime(500))
    .subscribe((res: any) => {
      
      if (this.field?.key ===  res.key) {
        // Split the values into an array
        const splitValues = res.value.split('|,|');
        
        // Filter options based on the matching values
        this.selectedItems = this.option.filter((item: any) => splitValues.find((o:any)=> o == item[this.field.key]));
        this.applyFilter();
      }
        // this.field.formControl?.setValue(this.selectedItems); 
        // this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, this.option, this.selectedItems, 'multiSelection', this.showBy, this.labelProp,"",this.option)
        // }
    }))

    this.label = this.field.templateOptions.label
    this.placeholder = this.field.templateOptions.placeHolder
    this.showBy = this.field.templateOptions.showBy
    this.opt = this.field.templateOptions || {};
    let ds = this.opt.dataSourceUrl
    this.itemsShowLimit = 2
    this.labelProp = this.opt.labelProp;
    this.valueProp = this.opt.valueProp;
    this.groupLabelProp = this.opt.groupLabelProp || this.groupLabelProp;
    this.isGrouped = this.opt.isGrouped || false;
    this.addParameter = this.opt.addParameter;
    this.toolTipKey = this.opt.toolTipVisible || this.labelProp;
    this.selectAllAsNull = this.opt.selectAllAsNull == 'yes' ? true : false;
    this.defaultFilter = this.opt.defaultFilter;
    this.userCanSelect = this.opt.userCanSelect || '';
    this.selectedDashboardKey = this.opt.selectedDashboardKey || '';
    this.mixPanelConfiguration = this.opt.mixPanelConfiguration == 'yes' ? true : false;
    this.apiJSonFlag = this.opt.apiJSon_flag == 'json' ? true : false;
    this.isdynamicLabel =  this.opt.isdynamicLabel??false
    this.staticKey = this.opt.staticKey
    this.staticValue = this.opt.staticValue
    this.additionalParameter = this.staticKey  ? {[this.staticKey]: this.staticValue} : undefined;
    this.decomm_flag = this.opt.decomm_flag == 'yes' ? true : false;
    this.decommReplaceName = this.opt.decommReplaceName || 'decomm_flg';
    this.decommColor = this.opt.decommColor || '#c04a36';
    this.decommlabel = this.opt.decommlabel || 'Decomm.';
    this.decommTooltip = this.opt.decommTooltip || 'Decommissioned';
    this.isRootSqBadge = this.opt.isRootSqBadge || false;

    // Inside your code
    if (this.field?.parentKey != "") {
      (this.field.hooks as any).afterViewInit = (f: any) => {
        const parentControl = this.form.get(this.field.parentKey);
        this.parentControlSubscription = parentControl?.valueChanges.pipe(debounceTime(500)).subscribe((val: any) => {
          let selectedOption = this.model[this.key as string];
// debugger
          // to empty for child model
          let key = this.key as string
         if(this.isdynamicLabel) {
          this.dynamicLabelConfiguration({[this.field.parentKey] : this.model[this.field.parentKey][this.field.parentKey]});}
          let fndChild: any = this.filterService.globalFilterFields.find((res: any) => key == res.parentKey)
          if (fndChild) {
            this.model[fndChild.key] = '';
            // User State
            // let ab = { [fndChild.key]: []}
            // this.userActivityService.setData({ "selectedFilters": ab })

            // delete this.filterService.previousSelectedItems?.[fndChild.key]
          }

          if (this.fndParent()) {
            if (ds == "") {
              this.opt.options = val;
              let v = val.find((d: any) => d[this.valueProp] == selectedOption[this.valueProp]);
              this.field.formControl?.setValue(v);
            } else {
              this.loadApiData(this.opt.method || "POST", ds, this.opt.parameter, this.model);
            }
          }
        });
        this.opt.options = [];
      };
    } else {
      this.loadApiData(this.opt.method || "POST", ds, this.opt.parameter, this.model);
    }
  }
  dynamicLabelConfiguration(parent_key:any) {
    let url='kpi/get-generic-filter-lable'
    let obj={
     "filter_type": this.key,
     ...parent_key
    }
      this.reqSubcription.push(this.filterService.dynamicLabelQuery(obj, url).subscribe((label: any) => {
        this.label = label[0]?.filter_label || this.label ;
          this.filterService.duplicateParameter['label'] = this.label;
        this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, this.option.length, this.selectedItems, 'multiSelection', this.showBy, this.labelProp,'',this.option,'',this.label,{isGrouped: this.isGrouped, groupLabelProp: this.groupLabelProp})

  
      }))
  }

  // Process data for grouping
  processGroupedData(data: any[]) {
    if (this.isGrouped) {
      // Separate items with null source_type (ungrouped) and items with source_type (grouped)
      const ungroupedItems = data.filter(item => item[this.groupLabelProp] === null || item[this.groupLabelProp] === undefined);
      const groupedItems = data.filter(item => item[this.groupLabelProp] !== null && item[this.groupLabelProp] !== undefined);
      
      // Return ungrouped items first, then grouped items
      return [...ungroupedItems, ...groupedItems];
    }
    return data;
  }

  // Get unique identifier for an item
  getItemIdentifier(item: any): any {
    const identifierProp = this.valueProp || (this.key as string);
    return item[identifierProp];
  }

  // Get group value from group object or string
  getGroupValue(groupValue: any): string {
    if (typeof groupValue === 'object' && groupValue !== null) {
      return groupValue[this.groupLabelProp] || '';
    }
    return groupValue || '';
  }

  // Get items by group
  getItemsByGroup(groupValue: any): any[] {
    const targetGroupValue = this.getGroupValue(groupValue);
    
    return this.option.filter((item: any) => {
      const itemGroupValue = item[this.groupLabelProp];
      // Handle null/undefined (ungrouped items)
      if (!targetGroupValue) {
        return !itemGroupValue || itemGroupValue === null || itemGroupValue === undefined;
      }
      return itemGroupValue === targetGroupValue;
    });
  }

  // Check if all items in a group are selected
  isGroupSelected(groupValue: any): boolean {
    const groupItems = this.getItemsByGroup(groupValue);
    if (groupItems.length === 0) return false;
    
    // Check if every item in the group is in selectedItems
    return groupItems.every((item: any) => 
      this.selectedItems.some((selected: any) => 
        this.getItemIdentifier(selected) === this.getItemIdentifier(item)
      )
    );
  }

  // Check if some (but not all) items in a group are selected
  isGroupIndeterminate(groupValue: any): boolean {
    const groupItems = this.getItemsByGroup(groupValue);
    if (groupItems.length === 0) return false;
    
    const selectedCount = groupItems.filter((item: any) => 
      this.selectedItems.some((selected: any) => 
        this.getItemIdentifier(selected) === this.getItemIdentifier(item)
      )
    ).length;
    
    return selectedCount > 0 && selectedCount < groupItems.length;
  }

  // Get checkbox state for group
  getGroupCheckboxState(groupValue: any): 'checked' | 'indeterminate' | 'unchecked' {
    const groupItems = this.getItemsByGroup(groupValue);
    if (groupItems.length === 0) return 'unchecked';
    
    const selectedCount = groupItems.filter((item: any) => 
      this.selectedItems.some((selected: any) => 
        this.getItemIdentifier(selected) === this.getItemIdentifier(item)
      )
    ).length;
    
    if (selectedCount === 0) return 'unchecked';
    if (selectedCount === groupItems.length) return 'checked';
    return 'indeterminate';
  }

  // Handle click on group div
  onGroupDivClick(groupValue: any, event: any): void {
    // Stop propagation to prevent ng-select from closing
    event.stopPropagation();
    event.preventDefault();
    
    this.toggleGroupSelection(groupValue, event);
  }

  // Toggle group selection
  toggleGroupSelection(groupValue: any, event: any): void {
    // Stop propagation to prevent ng-select from closing
    event.stopPropagation();
    
    const groupItems = this.getItemsByGroup(groupValue);
    const isSelected = this.isGroupSelected(groupValue);
    
    if (isSelected) {
      // Deselect all items in the group
      this.selectedItems = this.selectedItems.filter((selected: any) => 
        !groupItems.some((item: any) => 
          this.getItemIdentifier(item) === this.getItemIdentifier(selected)
        )
      );
    } else {
      // Select all items in the group that aren't already selected
      groupItems.forEach((item: any) => {
        const isAlreadySelected = this.selectedItems.some((selected: any) => 
          this.getItemIdentifier(selected) === this.getItemIdentifier(item)
        );
        if (!isAlreadySelected) {
          this.selectedItems.push(item);
        }
      });
    }
    
    // Create new array reference to trigger change detection
    this.selectedItems = [...this.selectedItems];
    
    // Update the select all checkbox state
    this.isChecked = (this.selectedItems.length === this.option.length);
    this.needsCheckboxUpdate = true;
    this.selectOption();
  }

  // Lifecycle hook to update checkbox states after view is checked
  ngAfterViewChecked(): void {
    if (this.needsCheckboxUpdate && this.isGrouped) {
      this.updateGroupCheckboxStates();
      this.needsCheckboxUpdate = false;
    }
  }

  // Update all group checkbox indeterminate states
  updateGroupCheckboxStates(): void {
    if (!this.option || this.option.length === 0) return;
    
    // Get all unique group values
    const groupValues = new Set<string>();
    this.option.forEach((item: any) => {
      const groupValue = item[this.groupLabelProp] || '';
      groupValues.add(groupValue);
    });
    
    // Update each group checkbox
    groupValues.forEach(groupValue => {
      const groupObj = { [this.groupLabelProp]: groupValue };
      const state = this.getGroupCheckboxState(groupObj);
      const checkboxId = `group-checkbox-${groupValue || 'ungrouped'}`;
      const checkbox = document.getElementById(checkboxId) as HTMLInputElement;
      
      if (checkbox) {
        checkbox.indeterminate = (state === 'indeterminate');
      }
    });
  }

  // ── Defect Field filter → Fix Files grid columns ────────────────────────────
  // The Fix Files grid narrows its visible columns to this filter's selection,
  // and cannot read that selection out of baseQuery reliably: setFilterValue
  // flattens a multi-select as `options.map(o => o[field.key])`, so unless the
  // configured param name is literally db_col_nm the query carries
  // "undefined,undefined,…". So this filter publishes its own db column names on
  // FilterService and mirrors them into duplicateParameter, which setFilterValue
  // merges into baseQuery under db_col_nm whatever this field's param name is.
  private static readonly DEFECT_FIELD_PROP = 'db_col_nm';

  // Latched when the options load, so the empty/error paths can still clear a
  // previously published selection once `option` has been emptied.
  private isDefectField = false;

  // Opt in from the designer (templateOptions.isDefectField: 'yes'), or infer it
  // from options that carry a db_col_nm of their own.
  private detectDefectFieldFilter(): boolean {
    if (this.opt?.isDefectField == 'yes') return true;
    return Array.isArray(this.option) &&
      this.option.some((o: any) => o != null && DynamicMultiSelect.DEFECT_FIELD_PROP in o);
  }

  private publishDefectFieldSelection(items: any[]): void {
    if (!this.isDefectField) return;

    const prop = DynamicMultiSelect.DEFECT_FIELD_PROP;
    const names = (items ?? [])
      .map((item: any) => String(item?.[prop] ?? '').trim())
      .filter((name: string) => name !== '');

    this.filterService.selectedDefectFields = names;
    if (names.length) {
      this.filterService.duplicateParameter[prop] = names.join(',');
    } else {
      // Nothing selected is "no restriction" — leave the key out entirely rather
      // than sending an empty string the API would have to interpret.
      delete this.filterService.duplicateParameter[prop];
    }
  }

  // Is Object or Array
  isObjectNotArray(value: any): boolean {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
  }

  // Find the Parent Key 
  fndParent() {

    let data: any;
    if (this.model[this.field.parentKey].length) {
      data = this.model[this.field.parentKey].find((r: any) => r[this.field.parentKey])
    } else if (this.isObjectNotArray(this.model[this.field.parentKey])) {
      if(this.model[this.field.parentKey] && this.model[this.field.parentKey][this.field.parentKey]) {
        data = this.model[this.field.parentKey][this.field.parentKey];
      } else {
        data = this.model[this.field.parentKey];
      }
    } else if (this.model[this.field.parentKey]) {
    }

    return data
  }

  // Load Api
  loadApiData(method: string, url: string, key: string, data: any) {
    this.reqSubcription.push(this.filterService.loadDataMultiselection(method, url, key, data, this.selectedDashboardKey=='pare_dashboard'?this.dashboardKey:this.dashboardService.dashboardKey, this.apiJSonFlag, this.field,this.additionalParameter).subscribe((data: any) => {

      if (data.length > 0) {
        
        this.option = data ? data : [];
        // Process data for grouping if key is source_key
        this.option = this.processGroupedData(this.option);
        this.isDefectField = this.detectDefectFieldFilter();
        
        // Default filter from designer
        if(this.defaultFilter) {
          let spltString = this.defaultFilter.split(',');
          let flrData = this.option.filter((f:any)=> spltString.find((o:any)=> o.toLowerCase() == f[this.key as string].toLowerCase()));
          this.option = [...flrData];
        }

        this.defalutOption = this.option;

        // Back up all data
        this.filterService.backupAllSingleAndMulti[this.field.key] = this.option;

        // Toget selected Source type from the configuration 
        let abcData: any = [];
        let comparedArray: any = [];
        if (this.filterService.selectedFilterValue?.['is_Selected'] == true) {
          abcData = this.filterService.selectedFilterValue['all_source_type'].filter((res: any) => 'source_type' == this.key && res.selected == true)
          if (abcData.length > 0) {
            comparedArray = data.filter((obj1: any) => abcData.some((obj2: any) => obj2[this.key as string].toString() == obj1[this.key as string].toString()));
          }
        }

        if (this.queryFilterData instanceof Array && this.queryFilterData?.length) {
          let selectedData: any = this.queryFilterData.find((o: any) => o.filterKey?.includes(this.field.key));
          if (selectedData) {
            const searchResult = this.option.find((obj: any) => {
              for (let key in obj) {
                if (obj[key]?.toString().toLowerCase() == selectedData[selectedData.key]?.toLowerCase()) {
                  return true;
                }
              }
              return false;
            });
            this.queryFilterData = searchResult;
          };
        }

        // from url
        let ifQuery: any;
        if (this.queryFilterData) {
          let queryFilter = Object.entries(this.queryFilterData).map(([key, value]) => ({ key, value }));
          ifQuery = queryFilter.find((fnd: any) => fnd.key == this.field.key)
        }

        // User State
        if (ifQuery && this.queryFilterData && ifQuery?.['value']) {
          let comparedArrayW = this.queryLoaded(ifQuery['value'])
          if (comparedArrayW.length > 0) {
            if (this.cardId == 'multi') {
              this.option = comparedArrayW
              this.selectedItems = comparedArrayW
              this.filterService.allOptionData['multi'][this.field.key] = this.selectedItems
            } else {
              if(this.bookmarkId && !isNaN(Number(this.bookmarkId)) && this.bookmarkId!='config' && this.field.key=='source_type') {
                this.option = comparedArray;
                this.selectedItems = comparedArrayW
                this.filterService.allOptionData['multi'][this.field.key] = this.option
              } else {
                this.selectedItems = comparedArrayW
                this.filterService.allOptionData['multi'][this.field.key] = this.option
              }
            }
          } else {
            this.selectedItems = this.userStoredData();
            this.filterService.allOptionData['multi'][this.field.key] = this.option
          }
        } else {
          if (comparedArray.length > 0) {
            this.option = comparedArray;
            this.selectedItems = this.userStoredData();
          } else {
            this.selectedItems = this.userStoredData();
          }
          this.filterService.allOptionData['multi'][this.field.key] = this.option
        }

        if(this.bookmarkId && !isNaN(Number(this.bookmarkId))) {
          // User State for only when bookmark ID present
          let ab = { [this.key as string]: this.selectedItems }
          this.userActivityService.setData({ "selectedFilters": ab })

          // user state for single selection
          if (this.cardId == 'multi') {
            let ab = { [this.key as string]: this.selectedItems }
            this.userActivityService.setDataKpiSingle({ "selectedFilters": ab })
          }
        }

        // If length is same all should checked
        if (this.selectedItems.length == this.option.length) {
          this.isChecked = true
        } else {
          this.isChecked = false
        }


        // Add Parameter like source key like all the key
        if (this.addParameter) {
          this.filterService.duplicateParameter[this.addParameter] = this.stringifyMode(this.selectedItems, this.addParameter)
        }

        this.filterService.selectedItem['multi'][this.field.key] = this.selectedItems
        this.filterService.previousSelectedItems[this.field.key] = this.selectedItems
        
        this.filterService.selectAllNullColumn[this.field.key] = "data";

        if(this.selectAllAsNull) {
          this.filterService.selectAllAsNull.push([this.field.key])
        }

        // Publish the initial (default) selection so the first grid load is
        // already scoped, not just later user applies.
        this.publishDefectFieldSelection(this.selectedItems);

        this.field.formControl?.setValue(this.selectedItems)
        this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, this.option.length, this.selectedItems, 'multiSelection', this.showBy, this.labelProp,'',this.option,'',this.label,{isGrouped: this.isGrouped, groupLabelProp: this.groupLabelProp})
      } else {
        // when there is no data in filter
        this.selectedItems = [];
        this.option = [];
        this.publishDefectFieldSelection([]);

        // Add Parameter like source key like all the key
        if (this.addParameter) {
          this.filterService.duplicateParameter[this.addParameter] = this.stringifyMode(this.selectedItems, this.addParameter)
        }
        this.filterService.allOptionData['multi'][this.field.key] = this.option
        this.filterService.selectedItem['multi'][this.field.key] = this.selectedItems
        this.filterService.previousSelectedItems[this.field.key] = this.selectedItems

        this.field.formControl?.setValue({ [this.key as string]: 'null' })
        this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, this.option.length, this.selectedItems, 'multiSelection', this.showBy, this.labelProp,"",this.option,'',this.label,{isGrouped: this.isGrouped, groupLabelProp: this.groupLabelProp})
      }
    }, err => {
      console.error("Error " + err)
      this.selectedItems = []
      this.option = []
      this.publishDefectFieldSelection([]);

      // Add Parameter like source key like all the key
      if (this.addParameter) {
        this.filterService.duplicateParameter[this.addParameter] = this.stringifyMode(this.selectedItems, this.addParameter)
      }

      this.filterService.allOptionData['multi'][this.field.key] = this.option
      this.filterService.selectedItem['multi'][this.field.key] = this.selectedItems
      this.filterService.previousSelectedItems[this.field.key] = this.selectedItems

      this.field.formControl?.setValue({ [this.key as string]: 'null' })
      this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, this.option.length, this.selectedItems, 'multiSelection', this.showBy, this.labelProp,"",this.option,'',this.label,{isGrouped: this.isGrouped, groupLabelProp: this.groupLabelProp})
    }));
  }

  queryLoaded(query: any) {
    let spltQuery = query.toString().split(',');
    let comparedArrayW = this.option.filter((obj2: any) => spltQuery.some((obj1: any) => obj2[this.field.key].toString().toLowerCase() == obj1.toString().toLowerCase()));
    return comparedArrayW || []
  }
  
  stringifyMode(selectedItems:any, addParameter:any) {
    if (selectedItems?.length == this.option.length && this.selectAllAsNull) return null;
    if (selectedItems?.length == 0) return null;
    let data = ''

    for (let index = 0; index < selectedItems.length; index++) {
      data += selectedItems[index][addParameter] + ','
    }

    return data.slice(0, data.lastIndexOf(","));
  }

  excludeMatchingElements(arr1: any[], arr2: any[]): any[] {
    return arr1.filter((item1: any) => !arr2.some((item2: any) => item2[this.field.key] == item1[this.field.key]));
    // Customize the condition based on the properties you want to compare
  }


  // User State 
  userStoredData() {
    let userStateData: any = this.userActivityService.getData()
    // Object into Array of Object
    let selectedOption: any
    let comparedArray: any = [];

    let updatesObj: any = Object.entries(userStateData.selectedFilters).map(([key, value]) => ({ key, value }));
    let findData: any = updatesObj?.find((o: any) => o.key == this.key as string)


    if (findData) {
      if (findData.value.length) {

        comparedArray = findData['value']?.filter((obj1: any) => this.option.some((obj2: any) => obj2[this.key as string].toString() == obj1[this.key as string].toString()));
        if (comparedArray.length > 0) {
          selectedOption = comparedArray
        } else {
          selectedOption = this.option
        }
      } else {
        selectedOption = this.findObjectsById(findData.value[this.key as string])
      }
    } else {
      selectedOption = this.option;
      if(this.userCanSelect) {
        selectedOption = this.option.slice(0, this.userCanSelect)
      }
    }
    return selectedOption
  }

  // Find Data using by ID
  findObjectsById(idToFind: any) {
    let myArray: any = []
    let selectedOption: any
    let fnd = this.option.find((o: any) => o[this.key as string] == idToFind)

    if (fnd) {
      myArray.push(fnd)
      selectedOption = myArray
    } else {
      selectedOption = this.option
    }

    return selectedOption
  }

  // Set Previous to get from service
  setPreviousItems() {
    this.filterService.previousSelectedItems[this.field.key] = this.selectedItems
    this.isChecked = (this.selectedItems.length == this.option.length)
    this.selectAllLabel = this.isChecked ? 'Select All' : 'Select All';
  }

  // Select All function
  selectAll() {
    this.selectedItems = []
    if (this.isChecked)
      this.option.map((o: any) => this.selectedItems.push(o));
    // if (this.selectedItems)
    // this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, this.option.length, this.selectedItems, 'multiSelection', this.showBy, this.labelProp)
  }

  selectAllClick() {
    this.isChecked = !this.isChecked
    this.selectAllLabel = this.isChecked ? 'Select All' : 'Select All';
    this.excelBasedFilter()
  }

  applyIncludeExcludeFilter(type: any, ctrl?: any) {
    const all = [...this.option];              // master list
    const selected = [...this.selectedItems];  // user selections

    if (type === 'include') {

      // if (!this.isAddChecked) {
        this.selectedItems = all.filter(opt =>
          selected.some(sel => sel[this.valueProp] === opt[this.valueProp])
        );
      // }

    } else if (type === 'exclude') {

      this.selectedItems = all.filter(opt =>
        !selected.some(sel => sel[this.valueProp] === opt[this.valueProp])
      );

    } else {

      this.selectedItems = [...all];

    }

    this.applyFilter(ctrl);
  }

  // Select Add CLick in Excel Filter
  selectAddClick() {
    this.isAddChecked = !this.isAddChecked

    let previousSelect: any = this.filterService.previousSelectedItems[this.field.key]
    if (this.isAddChecked) {
      if (previousSelect.length > 0) {
        this.selectedItems = previousSelect.concat(this.selectedItems);
        this.selectedItems = this.removeDublicates(this.selectedItems)
      }
    } else {
      this.selectedItems = this.removeSelectedObjects(this.selectedItems, previousSelect);
      this.selectedItems = this.removeDublicates(this.selectedItems)
    }
    if (this.selectedItems.length == 0) {
      this.isChecked = false;
    }
  }

  // Excel Based Filter
  excelBasedFilter() {
    if (this.enteredText) {
      let option = this.option.filter((f: any) => this.matchesSearch(f, this.enteredText))
      if (this.isChecked) {
        this.selectedItems = [...option];
      } else {
        this.selectedItems = []
      }
    } else {
      this.selectedItems = [];
      if (this.isChecked) {
        this.selectedItems = [...this.option]
      }
    }

    // this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, this.option.length, this.selectedItems, 'multiSelection', this.showBy, this.labelProp)
  }

  removeSelectedObjects(mainArray: any[], objectsToRemove: any[]): any[] {
    return mainArray.filter(obj => !objectsToRemove.some(remObj => remObj[this.field.key].toString().toLowerCase() == obj[this.field.key].toString().toLowerCase()));
  }

  removeDublicates(data: any) {
    return Array.from(new Set(data.map((item: any) => item[this.field.key]))).map(id => {
      return data.find((item: any) => item[this.field.key] === id);
    });
  }

  selectOption() {
    // Update select all checkbox state
    this.isChecked = (this.selectedItems.length == this.option.length)
    this.selectAllLabel = this.isChecked ? 'Select All' : 'Select All';
    
    // Update group selection states for all groups
    this.updateGroupSelectionStates();
    
    // Mark that checkboxes need visual update
    this.needsCheckboxUpdate = true;
    
    if (this.selectedItems.length == 0)
      this.isOpen = true;
    else
      this.isOpen = null
    // this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, this.option.length, this.selectedItems, 'multiSelection', this.showBy, this.labelProp)
  }

  // Update cached group selection states
  updateGroupSelectionStates() {
    if (!this.isGrouped || !this.option) return;
    
    // Get all unique group values
    const groupValues = new Set<string>();
    this.option.forEach((item: any) => {
      const groupValue = item[this.groupLabelProp] || '';
      groupValues.add(groupValue);
    });
    
    // Update state for each group
    groupValues.forEach(groupValue => {
      const groupObj = { [this.groupLabelProp]: groupValue };
      this.groupSelectionStates.set(groupValue, this.isGroupSelected(groupObj));
    });
  }

  getDifference(array1: any, array2: any) {
    return array1.filter(
      (object1: any) => !array2.some(
        (object2: any) => object1[this.key as string] == object2[this.key as string]
      ),
    );
  }

  getDeSelectedData(): any {
    const data: any = sessionStorage.getItem('deSelectedFilter');
    return JSON.parse(data) || this.deSelectedData;
  }

  deSelectedData: any = {
    'deSelect': {}
  }

  differenceOfDetails(data: any) {
    this.deSelectedData = this.getDeSelectedData();

    // Object into Array of Object
    let updatesObj: any = Object.entries(data).map(([key, value]) => ({ key, value }));

    for (let i = 0; i < updatesObj.length; i++) {
      if (updatesObj[i].key == "deSelect") {
        let Obj: any = Object.entries(updatesObj[i].value).map(([key, value]) => ({ key, value }));
        Obj.forEach((res: any) => {
          this.deSelectedData[updatesObj[i].key][res.key] = res.value
        })
      } else {
        this.deSelectedData[updatesObj[i].key] = updatesObj[i].value
      }
    }

    const serializedData: any = JSON.stringify(this.deSelectedData);
    sessionStorage.setItem('deSelectedFilter', serializedData);

  }

  applyFilter(ctrl?: any) {

    let key = this.key as string
    let fndChild: any = this.filterService.globalFilterFields.find((res: any) => key == res.parentKey)


    if (fndChild) {
      this.model[fndChild.key] = ''

      // User State
      let ab = { [fndChild.key]: [] }
      this.userActivityService.setData({ "selectedFilters": ab })

      delete this.filterService.previousSelectedItems?.[fndChild.key]
    }

    this.navigationService.filterSingleState(key);
    
    this.setPreviousItems();
    this.isOpen = null

    if (this.addParameter) {
      this.filterService.duplicateParameter[this.addParameter] = this.stringifyMode(this.selectedItems, this.addParameter)
    }

    // User State
    let ab = { [this.key as string]: this.selectedItems }
    this.userActivityService.setData({ "selectedFilters": ab })

    // user state for single selection
    if (this.cardId == 'multi') {
      let ab = { [this.key as string]: this.selectedItems }
      this.userActivityService.setDataKpiSingle({ "selectedFilters": ab })
    }

    // from network chart => status code and patient status
    let netWork: any = sessionStorage.getItem('net_status_flr')
    if (netWork) {
      netWork = JSON.parse(netWork)

      let updatesObj: any = Object.entries(netWork).map(([key, value]) => ({ key, value }));
      let findData: any = updatesObj.find((o: any) => o.key == key)

      if (findData) {
        delete netWork[findData.key]
        sessionStorage.setItem('net_status_flr', JSON.stringify(netWork))
      }
    }

    //  // KPI Break Down
    // let kpiCon:any = sessionStorage.getItem('selectedKPIcontrol')

    // if(kpiCon) {
    //   kpiCon = JSON.parse(kpiCon)

    //   let updatesObj: any = Object.entries(kpiCon).map(([key, value]) => ({ key, value }));
    //   let findKpi: any = updatesObj.find((o: any) => o.key == key)

    //   if(findKpi) {
    //     delete kpiCon[findKpi.key]
    //     sessionStorage.setItem('selectedKPIcontrol', JSON.stringify(kpiCon))
    //   }
    // }

    // Publish before the global apply reaches setFilterValue, which is where
    // duplicateParameter is merged into baseQuery.
    this.publishDefectFieldSelection(this.selectedItems);

    this.filterService.filterApplyBtn();

    if(this.mixPanelConfiguration) {
      let mixPanel = this.moduleName + ' - ' + this.dashboardService.dashboardName + ' - ' + this.label + ' - ' + 'Filter';
      this.mixpanelService.track(mixPanel);
    }

    this.filterService.selectedItem['multi'][this.field.key] = this.selectedItems;
    this.field.formControl?.setValue(this.selectedItems);
    this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, this.option.length, this.selectedItems, 'multiSelection', this.showBy, this.labelProp,"",this.option,'',this.label,{isGrouped: this.isGrouped, groupLabelProp: this.groupLabelProp});
    ctrl?.close();
  }

  // drop down close to get details
  onClose() {
    this.firstTime = true;
    this.isAddChecked = false;
    this.enteredText = ''
    if (this.filterService.previousSelectedItems?.[this.field.key].length == 0) {
      this.isChecked = true
      this.selectedItems = this.option
    } else {
      this.selectedItems = this.filterService.previousSelectedItems?.[this.field.key]
      this.isChecked = (this.selectedItems.length == this.option.length)
      this.selectAllLabel = this.isChecked ? 'Select All' : 'Select All';
    }
    this.filterService.setBadgeValue(this.key as string, this.selectedItems.length, this.option.length, this.selectedItems, 'multiSelection', this.showBy, this.labelProp,"",this.option,'',this.label,{isGrouped: this.isGrouped, groupLabelProp: this.groupLabelProp})
  }

  ngOnDestroy(): void {
    // duplicateParameter and selectedDefectFields outlive this field, so a stale
    // db_col_nm would otherwise leak into baseQuery on pages without this filter.
    if (this.isDefectField) {
      this.filterService.selectedDefectFields = [];
      delete this.filterService.duplicateParameter[DynamicMultiSelect.DEFECT_FIELD_PROP];
    }

    this.reqSubcription.forEach(res => res.unsubscribe())
    if (this.parentControlSubscription) {
      this.parentControlSubscription.unsubscribe();
    }
  }
}
